var _defs, _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyStream(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.538,
    height: 30.538,
    viewBox: "0 0 30.538 30.538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 21.971)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 4.279,
    cy: 4.279,
    r: 4.279
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,120.64v5.554A13.881,13.881,0,0,1,13.876,140.07H19.43A19.436,19.436,0,0,0,0,120.64Z",
    transform: "translate(0 -109.541)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0V5.554A24.985,24.985,0,0,1,24.984,30.538h5.554A30.547,30.547,0,0,0,0,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyStream);
export default __webpack_public_path__ + "static/media/my-stream.3d3cdfc02d2d5be62ea9832cef43ae97.svg";
export { ForwardRef as ReactComponent };